<template>
    <section>
        <el-drawer placement="right"  class="in" :visible="visible" size="80%" :show-close=false :append-to-body=true>
            <div slot="title" style="text-align:right">
                <el-button size="small" @click="close">关闭</el-button>
                <el-button size="small" type="primary" @click="submit" v-if="is_mutifily==0">保存</el-button>
            </div>

            <el-container style="height: 100%;">
                <el-main style="background-color:#f2f2f2;padding:20">
                    <el-row v-loading="loading" type="flex" style="flex-wrap:wrap">
                        <span v-if="list.length==0" style="color:#666666">暂无背景!</span>
                        <div v-for="(img,index) in list" :key="index"  class="img-card" 
                            @click="isCheckOne(img,index)" :class="img.checked&&is_mutifily!=2?'img-check':''">
                                <el-image :src="img.path" fit="cover"></el-image>
                            <div class="mark" v-if="is_mutifily!=2"> 
                                <span :class="img.checked?'el-icon-success':'el-icon-circle-check'" :style="img.checked?'color:#2EB6AA;':'color:#2EB6AA;'" style="font-size:30px;"></span>
                            </div>
                        </div>
                    </el-row>
                </el-main>
            </el-container> 
        </el-drawer>
    </section>
</template>

<script>
import { book } from "@/api/book";

export default {
    data(){
        return{
            visible:false,
            list:[],
            tpl_list:[],
            school_list:[],

            select_tpl:null,
            loading:false,

            is_mutifily:0,//0单选，1多选,2仅查看

            public_list:[],

            filters: {
                ispublic:null,
            },
            content_options:[],
            content_type:null,
            edit_index:null,  //edit_index=null添加,edit_index>=0修改时标记修改的索引值

            had_list:[],
            obj_data:{}

        }
    },

    computed: {
    },

    components:{
        
    },

    methods:{
        isCheckOne(img,index){
            if(this.is_mutifily==2){
                return
            }
            this.list.forEach((r,i)=>{
                if(this.is_mutifily==1){
                    r.checked=i==index?!r.checked:r.checked
                }else{
                    r.checked=i==index?!r.checked:false
                }
            })
            this.list.splice(index,1,this.list[index])
            this.had_list=this.list.filter(e=>e.checked)
        },
     
        setHadCur(data,index,type){  //修改某页
            this.visible=true
            this.obj_data=data
            this.list=data.tplBackGroundBOList
            this.edit_index=index
            this.is_mutifily=type
        },

        close(){
            this.visible=false
        },

        // 保存设置
        submit(){
            let tpl_back_group_list=this.list.filter(e=>e.checked)
            if(tpl_back_group_list.length==0){
                this.$message({ message: "未选择背景图！", type: "success" });
                return
            }
            let obj={
                tpl_back_group_list:this.list,
                config:this.obj_data.config?this.obj_data.config:null,
                data:this.obj_data.data?this.obj_data.data:[],
            }
            this.$emit('closeTpl',obj,this.edit_index)
        },
    },
    mounted(){
     
    }
}
</script>

<style scoped lang="scss">
.in /deep/ .el-drawer__header{
    margin-bottom: 10px;
}

.in /deep/ .el-drawer__body{
    background-color: #f2f2f2;
}
.img-card{
    // width: 258px;
    // height: 359px;
    width: 179px;
    height: 250px;
    margin: 0 16 10 0;
    position: relative;
    border: 1px solid #f2f2f2;
    background-size:cover;
    background-repeat:no-repeat;
    background-position: center center;
    .el-image{
        width: 100%;
        height: 100%;
    }
    .mark{
        position: absolute;
        top: 0;
        left:0;
    }
}
.img-check{
    border: 3px solid rgba(46, 182, 170, 1);
}

.el-main{
    padding:0 20;
}
.el-row{
    margin:0 0 10 0;
}


.aside-left{
    display:flex;
    flex-direction: column;
    background-color: #ffffff;
    .img-list{
        width: 179px;
        height: 250px;
        margin: 0 auto;
        padding-bottom: 20px;
        position: relative;
        border:1px solid #f2f2ff;
        margin-bottom: 20px;
        .mark{
            position: absolute;
            bottom: 0;
            left: 0;
            height: 30px;
            line-height: 39px;
            background-color: rgba(46, 182, 170, 1);
            display: flex;
            width: 131px;
            justify-content: space-around;
            .el-button{
                color:#ffffff;
                padding:0;
                font-size: 18px;
            }
        }
    }
}
.el-form-item{
    margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/book/contentTplList.vue